import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useToggle } from "../../hooks/useToggle";

import { RiArrowDropDownFill } from "react-icons/ri";
import { TbWorld } from "react-icons/tb";

import {
  LengDropMenu,
  LenguageSwichText,
  LenguageSwichWrapper,
} from "./LanguageBar.styled";
import { Flex } from "../ui-component/Flex/Flex";

const lenguage = ["UA", "RU"];

export const LanguageBar = ({ display }) => {
  const { isOpen, toggle, setIsOpen } = useToggle();
  const [currentLeng, setCurrentLeng] = useState(
    localStorage.getItem("leng") || "UA"
  );
  const { i18n } = useTranslation();
  window.setTimeout(() => setIsOpen(false), 5000);

  /* ---------------- функцыя фиксации текущего языка ---------------- */
  useEffect(() => {
    if (currentLeng) {
      i18n.changeLanguage(currentLeng.toLowerCase());
    }
  }, [currentLeng, i18n]);

  /* ------------------------------- смена языка ------------------------------ */
  const onChangeLeng = (leng) => {
    const toLowerText = leng.toLowerCase();
    localStorage.setItem("leng", leng);
    i18n.changeLanguage(toLowerText);
    setCurrentLeng(leng);
    toggle();
  };

  return (
    <>
      <LenguageSwichWrapper display={display}>
        <Flex mobileAlign="center" align="center" onClick={toggle}>
          <LenguageSwichText>{currentLeng}</LenguageSwichText>
          <TbWorld style={{ width: "24px", height: "24px" }} />
          <RiArrowDropDownFill />
        </Flex>
        {/* условие отрисовки меню */}
        {isOpen && (
          <LengDropMenu>
            {lenguage.map((el) => (
              <li key={el} onClick={() => onChangeLeng(el)}>
                {el}
              </li>
            ))}
          </LengDropMenu>
        )}
      </LenguageSwichWrapper>
    </>
  );
};
